import { createRouter, createWebHistory } from 'vue-router'

const scrollToRouteTarget = (to) => {
  const scroller = document.querySelector('.overflow-y-scroll')
  if (!scroller) {
    return
  }

  if (!to.hash) {
    scroller.scrollTo({
      top: 0,
      behavior: 'auto',
    })
    return
  }

  const target = document.querySelector(decodeURIComponent(to.hash))
  if (!target) {
    return
  }

  const scrollerRect = scroller.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()
  const top = scroller.scrollTop + (targetRect.top - scrollerRect.top) - 16

  scroller.scrollTo({
    top: Math.max(top, 0),
    behavior: 'smooth',
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (savedPosition) {
            const scroller = document.querySelector('.overflow-y-scroll')
            if (scroller) {
              scroller.scrollTo({
                top: savedPosition.top,
                left: savedPosition.left,
                behavior: 'auto',
              })
            }
          } else {
            scrollToRouteTarget(to)
          }

          resolve(false)
        })
      })
    })
  },
  routes: [
    {
      path: '/',
      name: 'root',
      component: () => import('@/views/Root.vue'),
    },
    {
      path: '/resume',
      name: 'resume',
      component: () => import('@/views/Resume.vue'),
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/views/Projects.vue'),
    },
    {
      path: '/projects/:slug',
      name: 'project',
      component: () => import('@/views/Project.vue'),
    },
  ],
})

export default router
